import React, { useState, useEffect } from 'react';
import { requireLogin, getToken } from '../auth.js';
import { startSubscription, cancelSubscription, getSubscriptionStatus } from '../payments.js';
import './SubscriptionManager.css';

export default function SubscriptionManager() {
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCardForm, setShowCardForm] = useState(false);

  useEffect(() => {
    updateSubscriptionStatus();
  }, []);

  const updateSubscriptionStatus = () => {
    const status = getSubscriptionStatus();
    setSubscriptionStatus(status);
  };

  const handleSubscribe = async () => {
    const user = requireLogin();
    if (!user) return;

    setLoading(true);
    setShowCardForm(true);
    
    try {
      await startSubscription();
    } catch (error) {
      console.error('Subscription error:', error);
      alert('Error starting subscription: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    if (!confirm('Are you sure you want to cancel your subscription? You will lose access to AI tools immediately.')) {
      return;
    }

    setLoading(true);
    try {
      await cancelSubscription();
      updateSubscriptionStatus();
    } catch (error) {
      console.error('Cancel error:', error);
      alert('Error cancelling subscription: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const isActive = subscriptionStatus?.active && subscriptionStatus?.notExpired;

  return (
    <div className="subscription-manager">
      <div className="subscription-header">
        <h2>Subscription Management</h2>
        <div className={`subscription-status ${isActive ? 'active' : 'inactive'}`}>
          {isActive ? '🟢 Active' : '🔴 Inactive'}
        </div>
      </div>

      <div className="subscription-details">
        <div className="detail-row">
          <span>Plan:</span>
          <span className="plan-name">{subscriptionStatus?.plan || 'Free'}</span>
        </div>
        {subscriptionStatus?.currentPeriodEnd && (
          <div className="detail-row">
            <span>Next billing:</span>
            <span>{new Date(subscriptionStatus.currentPeriodEnd * 1000).toLocaleDateString()}</span>
          </div>
        )}
        {subscriptionStatus?.subscriptionId && (
          <div className="detail-row">
            <span>Subscription ID:</span>
            <span className="subscription-id">{subscriptionStatus.subscriptionId}</span>
          </div>
        )}
      </div>

      <div className="subscription-actions">
        {!isActive ? (
          <button 
            className="btn-subscribe" 
            onClick={handleSubscribe}
            disabled={loading}
          >
            {loading ? 'Setting up...' : 'Subscribe Now'}
          </button>
        ) : (
          <button 
            className="btn-cancel" 
            onClick={handleCancel}
            disabled={loading}
          >
            {loading ? 'Cancelling...' : 'Cancel Subscription'}
          </button>
        )}
      </div>

      {showCardForm && !isActive && (
        <div className="card-form-container">
          <h3>Enter Payment Information</h3>
          <div id="card-container" className="card-input"></div>
          <button id="card-submit" className="btn-submit-card">
            Complete Subscription
          </button>
          <button 
            className="btn-cancel-form"
            onClick={() => setShowCardForm(false)}
          >
            Cancel
          </button>
        </div>
      )}

      <div className="subscription-info">
        <h4>What's Included:</h4>
        <ul>
          <li>✅ Access to all AI tools</li>
          <li>✅ Unlimited usage</li>
          <li>✅ Priority support</li>
          <li>✅ Monthly billing</li>
        </ul>
        <p className="price">$9.99/month</p>
      </div>
    </div>
  );
}

